var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"chart"}),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_vm._v("Carregando")])])}
var staticRenderFns = []

export { render, staticRenderFns }